import { render, staticRenderFns } from "./GroupsPage.html?vue&type=template&id=778aac62&scoped=true&"
import script from "./GroupsPage.ts?vue&type=script&lang=ts&"
export * from "./GroupsPage.ts?vue&type=script&lang=ts&"
import style0 from "./GroupsPage.scss?vue&type=style&index=0&id=778aac62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778aac62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
